import { Spinner } from "@onengine/component-library";
import { PlanCard } from "@/components/features/FormBuilder/Assistant/PlanCard";
import type {
  AssistantNewFormRequest,
  AssistantPlan,
} from "@/api/form-builder/formAssistant.types";
import type { NewFormStatus } from "@/store/form-builder/useAssignmentsAssistantStore";
import panelStyles from "@/components/features/FormBuilder/Assistant/Assistant.module.scss";
import { slotLabelOf } from "./slotLabel";

interface NewFormCardProps {
  request: AssistantNewFormRequest;
  plan: AssistantPlan | null;
  status: NewFormStatus;
  isBusy: boolean;
  onApprove: () => void;
  onChange: () => void;
  onCancel: () => void;
}

export function NewFormCard({
  request,
  plan,
  status,
  isBusy,
  onApprove,
  onChange,
  onCancel,
}: NewFormCardProps) {
  const slot = slotLabelOf(request.workOrderType, request.formType);

  if (status === "planning" || !plan) {
    return (
      <section className={panelStyles.proposalCard} aria-label="New form">
        <span className={panelStyles.cardTitle}>{request.name}</span>
        <span className={panelStyles.cardMeta}>New form for {slot}</span>
        {status === "planning" ? (
          <p className={panelStyles.busy}>
            <Spinner size="small" />
            Planning the form
          </p>
        ) : (
          <span className={panelStyles.statusChip}>Could not plan this form</span>
        )}
      </section>
    );
  }

  return (
    <div aria-label="New form">
      <span className={panelStyles.cardMeta}>
        New form for {slot}: <strong>{request.name}</strong>
      </span>
      <PlanCard
        plan={{ ...plan, title: plan.title || request.name }}
        status={status === "failed" ? "cancelled" : status}
        isBusy={isBusy}
        onApprove={onApprove}
        onChange={onChange}
        onCancel={onCancel}
        approveHint={`Approving opens it in the form builder and builds it in the preview. Publishing it brings you back here to apply it to ${slot}.`}
      />
    </div>
  );
}
